
export const isEmpty = (obj) => {
	return Boolean(
		!obj ||
		(Object.keys(obj).length === 0 && obj.constructor === Object) ||
		(obj.length === 0 && obj.constructor === Array)
	);
};